import type { VFC } from 'react';
import { Form, Input } from '@/components/form';
import { FormattedMessage, useIntl } from '@/components/formatted_message/FormattedMessage';
import { StyledFormWrapper } from '@/routes/auth/components/FormContainer';
import { ButtonAnt } from '@/components/buttons/button/ButtonAnt';
import { TRANSLATED_ACTIONS } from '@/common/messages';
import { useAuthContext } from '@/contexts/AuthContext';
import { commonMessages } from '../../../messages';
import { Form as messages } from '../messages';
import { useHistory } from 'react-router-dom';
import { Flex } from 'antd';

interface RecoveryFormValues {
  email: string;
}

export const RecoveryForm: VFC = () => {
  const intl = useIntl();
  const [form] = Form.useForm<RecoveryFormValues>();
  const { resetPassword, isLoading, identifiedUser } = useAuthContext();
  const history = useHistory();

  const handleSubmit = ({ email }: RecoveryFormValues) => {
    resetPassword({ email });
  };

  return (
    <StyledFormWrapper>
      <Form
        form={form}
        layout="vertical"
        initialValues={{ email: identifiedUser?.identifier || '' }}
        onFinish={handleSubmit}
      >
        <Flex vertical gap={12}>
          <Form.Item
            name="email"
            label={intl.formatMessage(messages.email)}
            rules={[
              {
                required: true,
                message: intl.formatMessage(commonMessages.emailRequired),
                validateTrigger: 'onSubmit',
              },
              {
                type: 'email',
                message: intl.formatMessage(commonMessages.emailNotValid),
                validateTrigger: 'onSubmit',
              },
            ]}
          >
            <Input
              autoFocus
              data-cy="forgotPassword-email"
              data-test="forgotPassword-email"
              placeholder={intl.formatMessage(messages.email)}
            />
          </Form.Item>
          <Flex vertical gap={4}>
            <Form.Item>
              <ButtonAnt
                data-cy="forgotPassword-submit-button"
                data-test="forgotPassword-submit-button"
                htmlType="submit"
                loading={isLoading}
                type="primary"
                size="large"
              >
                <FormattedMessage {...TRANSLATED_ACTIONS.send} />
              </ButtonAnt>
            </Form.Item>
            <Form.Item>
              <ButtonAnt
                data-cy="forgotPassword-cancel-button"
                data-test="forgotPassword-cancel-button"
                type="default"
                size="large"
                onClick={() => history.push('/')}
              >
                <FormattedMessage {...TRANSLATED_ACTIONS.cancel} />
              </ButtonAnt>
            </Form.Item>
          </Flex>
        </Flex>
      </Form>
    </StyledFormWrapper>
  );
};
